import * as THREE from "three";
import CANNON from "cannon";
import { DiceManager, DiceD4, DiceD6, DiceD8, DiceD10, DiceD12, DiceD20 } from "./threejs-dices";

export default class DicesController {

	constructor() {
		this.scene = new THREE.Scene();
		this.camera = new THREE.PerspectiveCamera( 60, (window.innerWidth) / window.innerHeight, 0.1, 10000 );
		this.renderer = new THREE.WebGLRenderer({ alpha: true });
		this.world = new CANNON.World();

		this.dice = [];
		this.zoom = 7;
		this.worldWidth = 0;
		this.worldHeight = 0;
		this.worldDiagonal = 0;
		this.lastAngle = (Math.floor(4*Math.random())+1)*Math.PI/2;
		this.screenWidth = 0;
		this.screenHeight = 0;
		this.lastThrow = 0;
		this.lastUsedDice = [0,0,0,0,0,0];
	}

	init() {
		const el = document.querySelector('#eventHandler');
		this.screenWidth = el.offsetWidth;
		this.screenHeight = el.offsetHeight || 1;

		const cld = () => {
			this.clearDices();
		};

		el.addEventListener('click', cld);

		this.camera.aspect = this.screenWidth/this.screenHeight
		this.camera.updateProjectionMatrix();
		this.renderer.setSize(this.screenWidth, this.screenHeight);
		
		let ambient = new THREE.AmbientLight("#ffffff", 0.3);
		this.scene.add(ambient);

		let light = new THREE.SpotLight("#ffffff", 1.3);
		light.position.x = -10000;
		light.position.y = 10000;
		light.position.z = -10000;
		light.target.position.set(0, 0, 0);
		this.scene.add(light);

		this.world.gravity.set(0, -9.82 * 5, 0);
		this.world.broadphase = new CANNON.NaiveBroadphase();
		this.world.solver.iterations = 16;

		DiceManager.setWorld(this.world);

		const floorBody = new CANNON.Body({
			mass: 0,
			shape: new CANNON.Plane(),
			material: DiceManager.floorBodyMaterial
		});
		floorBody.quaternion.setFromAxisAngle(new CANNON.Vec3(1, 0, 0), -Math.PI / 2);
		this.world.add(floorBody);

		const container = document.querySelector("#dice3d");
		container.appendChild(this.renderer.domElement);

		this.camera.position.set(0, 20, 0);
		this.camera.lookAt( 0, 0, 0 );
		this.camera.up.set( 0, 0, 1 );




		/*var g = new THREE.PlaneGeometry(1,1);
		var m = new THREE.MeshBasicMaterial({
            color: "#00ff00",
            side: THREE.DoubleSide
        });
		this.cube = new THREE.Mesh(g, m);
		this.cube.position.set(0,0,0);
		this.cube.rotateX(-Math.PI/2);
		this.scene.add(this.cube);*/

		this.createDicesBench();
		this.animate();

		return () => {
			el.removeEventListener('click', cld);
			container.innerHTML = '';
		}
	}

	animate() {
		this.world.step(1.0 / 60.0);
	
		for (var i in [4,6,8,10,12,20]) {
			for (var j in this.dice[i]) {
				this.dice[i][j].dice.updateMeshFromBody();
			}
		}

		this.renderer.render(this.scene, this.camera);
		
		requestAnimationFrame(()=>this.animate());
	};

	idealDepthToZoomLevel() {
		const world2DSize = this.screenHeight/(this.zoom*10);

		const t = world2DSize/2;
		const f = Math.PI/6;

		this.worldHeight = t;
		this.worldWidth = this.camera.aspect * t;
		this.worldDiagonal = Math.sqrt(this.worldWidth**2 + this.worldHeight ** 2);

		return Math.cos(f)*t/Math.sin(f);
	};

	setZoom(lv) {
		this.zoom = lv;

		this.camera.position.y = this.idealDepthToZoomLevel();
		this.camera.lookAt.y = 0;
		
	}

	setCenter(center) {
		this.camera.lookAt.x = center[0];
		this.camera.lookAt.z = center[1];

		this.camera.position.x = center[0];
		this.camera.position.z = center[1];
	}

	generateDicePos() {
		this.lastAngle += Math.PI/2;

		if (this.lastAngle >= 2*Math.PI) {
			this.lastAngle -= 2*Math.PI;
		}

		const dirX = Math.cos(this.lastAngle);
		const dirZ = Math.sin(this.lastAngle);

		const x = Math.min(Math.max(-this.worldWidth, (this.worldDiagonal)*dirX), this.worldWidth);
		const z = Math.min(Math.max(-this.worldHeight, (this.worldDiagonal)*dirZ), this.worldHeight);
		const speed = 5;

		//this.cube.position.x = x + this.camera.position.x;
		//this.cube.position.z = z + this.camera.position.z;

		return {
			x: x + this.camera.position.x,
			y: this.camera.position.y**2/23,
			z: z + this.camera.position.z,
			speed,
			ang: this.lastAngle + Math.PI,
		}
	}

	createDicesBench() {
		this.dice = [];
		const dicesType = [DiceD4, DiceD6, DiceD8, DiceD10, DiceD12, DiceD20];

		for (let i in dicesType) {
			this.dice[i] = [];
			const DType = dicesType[i];
			const d = new DType({ size: 0.5, backColor: "#ffffff", fontColor: "#000000"});
			d.getObject().position.set(10000,0,10000+i*2);
			d.updateBodyFromMesh();
			this.scene.add(d.getObject());
			this.dice[i].push({dice: d, value: 1});
		}
	}

	clearDices() {
		const now = (new Date()).getTime();
		if (this.lastThrow > now - 10000) {
			return;
		}

		for(let i in this.dice) {
			if (this.dice[i] && this.dice[i].length) {
				for(let j in this.dice[i]) {
					this.scene.remove(this.dice[i][j].dice.getObject());
				}
			}
		}

		this.dice = [[],[],[],[],[],[]];
		this.lastUsedDice = [0,0,0,0,0,0];
	}

	resetAllDices() {
		const now = (new Date()).getTime();
		const shouldClean = this.lastThrow < now - 10000;
		this.lastThrow = now;

		if (!shouldClean) {
			return;
		}
		
		this.lastUsedDice = [0,0,0,0,0,0];

		for(let i in this.dice) {
			for(let j in this.dice[i]) {
				let currentPos = this.dice[i][j].dice.getObject().position;
				
				this.scene.remove(this.dice[i][j].dice.getObject());

				this.dice[i][j].dice.reset();
				this.dice[i][j].dice.getObject().position.set(10000 + currentPos.x,0, 10000 + currentPos.z);
				this.dice[i][j].dice.updateBodyFromMesh();

				this.scene.add(this.dice[i][j].dice.getObject());
			}
		}
	}

	addDice(color, font, rolls) {
		this.resetAllDices();

		let diceValues = [];
		const dicesType = [DiceD4, DiceD6, DiceD8, DiceD10, DiceD12, DiceD20];
		let dicesToThrow = [
			{count:0, type: 4, values: []},
			{count:0, type: 6, values: []},
			{count:0, type: 8, values: []},
			{count:0, type: 10, values: []},
			{count:0, type: 12, values: []},
			{count:0, type: 20, values: []},
		];

		for (let roll of rolls) {
			for(let i in dicesToThrow) {
				if (dicesToThrow[i].type === roll.diceType) {
					dicesToThrow[i].count += roll.values.length;
					dicesToThrow[i].values = [...dicesToThrow[i].values, ...roll.values];
				}
			}
		}

		let dicePos = this.generateDicePos();

		for (let i in dicesToThrow) {
			const diceMaxIndex = this.lastUsedDice[i] + dicesToThrow[i].count;
			const initialDiceUsed = this.lastUsedDice[i];
			for (let j=this.lastUsedDice[i]; j<diceMaxIndex; j++) {
				if (j >= 10) {
					continue;
				}
				const count = j-initialDiceUsed;
				
				let randAng = dicePos.ang + (-Math.PI/18) + (Math.random() * Math.PI/9);
				if (randAng < 0) {
					randAng += 2*Math.PI;
				}
				const xRand = Math.cos(randAng) * dicePos.speed;
				const yRand = Math.random() * 5 + 5;
				const zRand = Math.sin(randAng) * dicePos.speed;

				if (!this.dice[i][j]) {
					const DType = dicesType[i];
					const d = new DType({ size: 0.5, backColor: "#ffffff", fontColor: "#000000"});

					d.getObject().position.set(10000+j*2,0,10000+i*2);
					d.updateBodyFromMesh();
					this.scene.add(d.getObject());
					this.dice[i].push({dice: d, value: 1});
				}

				this.dice[i][j].dice.setDiceColors(font, color);

				this.dice[i][j].dice.getObject().position.x = dicePos.x - (count % 3);
				this.dice[i][j].dice.getObject().position.y = dicePos.y + Math.floor(count / 3);
				this.dice[i][j].dice.getObject().position.z = dicePos.z + (count % 3);

				this.dice[i][j].dice.getObject().quaternion.x = ((Math.random() * 90 - 45) * Math.PI) / 180;
				this.dice[i][j].dice.getObject().quaternion.y = ((Math.random() * 90 - 45) * Math.PI) / 180;

				this.dice[i][j].dice.updateBodyFromMesh();

				this.dice[i][j].dice.getObject().body.velocity.set(xRand, yRand, zRand);
				this.dice[i][j].dice.getObject().body.angularVelocity.set(5 * Math.random() - 2.5, 5 * Math.random() - 2.5, 5 * Math.random() - 2.5);

				this.lastUsedDice[i] += 1;
				diceValues.push({ dice: this.dice[i][j].dice, value: dicesToThrow[i].values[count] });
			}
		}

		if (diceValues && diceValues.length) {
			setTimeout(() => {
				DiceManager.prepareValues(diceValues);
			}, 100);
		}
	}
};